const chat = {
  title: 'Chat',
  acceptTerms: 'Mit der Übermittlung meiner Daten an die ausgewählte Apotheke nach Maßgabe der Datenschutzhinweise bin ich einverstanden.',
  info: 'Datenschutz • Der Chat-Inhalt kann jederzeit durch die Nutzung der "Beenden"-Funktion dauerhaft entfernt werden. Außerdem werden die Chat-Inhalte bei einem Apothekenwechsel automatisch gelöscht.',
  buttonText: 'Jetzt chatten',
}

export default chat
